import { render, staticRenderFns } from "./FarmCardItemSkeleton.vue?vue&type=template&id=459508f0&lang=pug&functional=true&"
import script from "./FarmCardItemSkeleton.vue?vue&type=script&lang=js&"
export * from "./FarmCardItemSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./FarmCardItemSkeleton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports